// Library import
import { useState, useEffect } from 'react';
import Proptypes, { object } from 'prop-types';
import { Modal, Alert } from 'react-bootstrap';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import { PostApi } from '@/http';
import { formatDate } from '@/config';

export const CopyPostModal = ({ show, handleClose, postList, selectedItem }) => {
  const [configs, setConfigs] = useState({
    btnCopyPost: false,
    serverError: ''
  });

  /**
   * Handle copy post
   */
  const handleCopyPost = async (event) => {
    event.preventDefault();
    // init
    let formData = new FormData();
    let count = 0;
    for (const post of postList) {
      if (!post.title.includes(selectedItem.title)) continue;
      if (post.title.includes(selectedItem.title) && post.title.includes('コピー')) {
        count++;
        continue;
      }
      count = 1;
    }

    let itemCopy = {};
    itemCopy.title = `${selectedItem?.title}のコピー${count}`;
    itemCopy.published_at = `${formatDate(new Date(), 'YYYY-MM-DD')}`;
    itemCopy.expired_at = '';
    itemCopy.status = 'draft';
    itemCopy.type = selectedItem.type;
    itemCopy.image = selectedItem?.original_image;
    itemCopy.url = selectedItem?.url;
    itemCopy.tags = JSON.stringify(selectedItem?.tags);
    itemCopy.items = selectedItem?.items;
    itemCopy.notification_flg = selectedItem?.notification_flg;
    itemCopy.calendar_info = selectedItem?.calendar_info;
    itemCopy.user_name = selectedItem?.user_name;

    //copy image
    if(selectedItem?.original_image && selectedItem?.original_image != "null") {
      const response = await PostApi.copyImage({path: selectedItem?.original_image, count: count});
      if (response.status === 200) {
        itemCopy.image = response.data.data.path;
      }
    }

    // data row
    for (const key in itemCopy) {
      const element = itemCopy[key];
      if (key === 'items' && Array.isArray(element) && element) {
        // items
        element.forEach((item, itemIdx) => {
          // title
          formData.append(`${key}[${itemIdx}][title]`, item.title ? item.title : '');
          Object.keys(item).forEach((keyItem) => {
            switch (keyItem) {
              case 'description': // description
                formData.append(`${key}[${itemIdx}][description]`, item?.description !== null ? item.description : '');
                break;
              case 'sub_items': // sub_items
                formData.append(`${key}[${itemIdx}][sub_items][title]`, item.title);
                item.sub_items.forEach(async(subItem, subItemIdx) => {
                  // title, description, image_url
                  formData.append(`${key}[${itemIdx}][sub_items][${subItemIdx}][title]`, subItem.title);
                  formData.append(`${key}[${itemIdx}][sub_items][${subItemIdx}][description]`, subItem.description);
                  formData.append(`${key}[${itemIdx}][sub_items][${subItemIdx}][image_url]`, subItem.image_url);
                    
                  if(subItem.image_url && subItem.image_url != "null") {
                    const prefixPath = subItem.image_url.substring(0, subItem.image_url.indexOf("."));
                    const suffixesPath = subItem.image_url.substring(subItem.image_url.indexOf("."), subItem.image_url.length);
                    const urlImageCopied = prefixPath + "_copy" + count + suffixesPath;
                    formData.append(`${key}[${itemIdx}][sub_items][${subItemIdx}][image_url]`, urlImageCopied);
                    await PostApi.copyImage({path: subItem.image_url, count: count});
                  }
                });
                break;
              case 'map_items': // map_items
                item.map_items.forEach((map, mapIdx) => {
                  Object.entries(map).forEach(([mapKey, mapVal]) => {
                    formData.append(`${key}[${itemIdx}][map_items][${mapIdx}][${mapKey}]`, mapVal ? mapVal : '');
                  });
                });
                break;
              default:
                break;
            }
          });
        });
      } else {
        formData.append(key, element !== null ? element : '');
      }
    }

    // Call api
    try {
      setConfigs({ ...configs, btnCopyPost: true });
      const response = await PostApi.createPost(formData);
      if (response.status === 200) {
        localStorage.setItem('post_info', selectedItem?.id + ' ' + selectedItem?.title);
        window.location.reload();
      }
    } catch (error) {
      setConfigs({ ...configs, btnCopyPost: false, serverError: 'Server error occured !' });
    }
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered animation={true} className='modal-wrapper' backdrop='static'>
        <div className='p-5'>
          <div className='modal-common-content text-center'>
            <p className='text my-4'>{selectedItem?.title}の記事をコピーします。 宜しいですか ?</p>
            <div className='action-btn d-flex justify-content-center align-items-center'>
              <button disabled={configs.btnCopyPost} className='button primary' onClick={handleCopyPost}>
                コピー
              </button>
              <button className='button outline' onClick={handleClose}>
                キャンセル
              </button>
            </div>
          </div>
          {/* Server error */}
          {configs.serverError && <Alert variant='danger'>{configs.serverError}</Alert>}
          <div className='close-modal' onClick={handleClose}>
            <img src={CrossIcon} alt='Cross icon' />
          </div>
        </div>
      </Modal>
    </div>
  );
};
CopyPostModal.prototype = {
  show: Proptypes.bool,
  handleClose: Proptypes.func,
  selectedItem: Proptypes.object,
  postList: Proptypes.array,
  queryParam: Proptypes.object
};

export const CopySuccessModal = ({show, handleClose}) => {
  const [showModal, setShowModal] = useState(show);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(false);
    }, 2000);

    localStorage.removeItem("post_info");
    return () => clearTimeout(timer);
  }, []);     
  
  return (
    <div>
      <Modal show={showModal} onHide={handleClose} centered animation={true} className='modal-wrapper' backdrop='static'>
        <div className='p-5'>
          <div className='modal-common-content text-center'>
            <p className='text my-4'>{localStorage.getItem("post_info")}のコピーが完了しました。</p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

CopySuccessModal.prototype = {
  show: Proptypes.bool,
  handleClose: Proptypes.func,
};
